export default __webpack_public_path__ + "static/media/expPink.40a7690a.svg";